import React, { useRef, useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts';

const COLORS = ['#2563eb', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

const TopBusinessesOrdersChart = ({ data }) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const measure = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  const processedData = Array.isArray(data) ? data : [];

  const topBusinesses = processedData
    .filter(b => b.total_orders > 0)
    .slice(0, 5)
    .map(b => ({
      name: b.business_name.length > 12 ? b.business_name.substring(0, 12) + '…' : b.business_name,
      orders: b.total_orders,
    }));

  if (topBusinesses.length === 0) {
    return (
      <div
        className="bar-chart-container"
        style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}
      >
        <h3 style={{ fontSize: '14px', fontWeight: '700', margin: '0 0 12px 0', color: '#1a1a1a' }}>Top 5 Businesses by Orders</h3>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '160px', color: '#6b7280' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>📦</div>
            <p style={{ fontSize: '12px', margin: 0 }}>No order data available</p>
          </div>
        </div>
      </div>
    );
  }

  const chartH = 220;

  return (
    <div
      className="bar-chart-container"
      style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}
    >
      <h3 style={{ fontSize: '14px', fontWeight: '700', margin: '0 0 12px 0', color: '#1a1a1a' }}>Top 5 Businesses by Orders</h3>
      {/* measure div — no overflow:hidden so offsetWidth is accurate */}
      <div ref={containerRef} style={{ width: '100%' }}>
        {containerWidth > 0 && (
          <BarChart
            width={containerWidth}
            height={chartH}
            data={topBusinesses}
            margin={{ top: 5, right: 10, left: 0, bottom: 50 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
            <XAxis dataKey="name" angle={-40} textAnchor="end" height={60} tick={{ fontSize: 10 }} stroke="#6b7280" />
            <YAxis tick={{ fontSize: 11 }} stroke="#6b7280" />
            <Tooltip
              formatter={v => [v, 'Orders']}
              contentStyle={{ backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '12px' }}
            />
            <Bar dataKey="orders" radius={[4, 4, 0, 0]}>
              {topBusinesses.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Bar>
          </BarChart>
        )}
      </div>
    </div>
  );
};

export default TopBusinessesOrdersChart;
